/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCouponUsageSummary } from './BaseCouponUsageSummary';
const TenantCouponUsageSummaryParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('tenant')],
]), BaseCouponUsageSummary);
export class TenantCouponUsageSummary extends BaseCouponUsageSummary {
    static decode(input) {
        return TenantCouponUsageSummaryParser.decode(input).map(res => new TenantCouponUsageSummary(res));
    }
    static unsafeDecode(input) {
        return TenantCouponUsageSummary.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantCouponUsageSummaryParser.encode(data);
    }
    static schema() {
        return TenantCouponUsageSummaryParser.schema();
    }
}
